<template>
  <div>
    <div>
      <p class="text-body-1 font-weight-bold" style="margin-top: 16px">Read Roles</p>
      <v-select
        class="selector"
        v-if="editable"
        label="Add Role"
        item-value="roleCode"
        item-text="roleDescription"
        :items="remainingReadRoles"
        @input="addReadRole"
      >
      </v-select>
      <v-chip
        class="chip"
        v-for="role in articleRoles.read"
        :close="editable"
        :key="role"
        @click:close="removeReadRole(role)"
      >{{role}}
      </v-chip>
      <v-chip v-if="articleRoles.read.length === 0">All</v-chip>
    </div>

    <div>
      <p class="text-body-1 font-weight-bold" style="margin-top: 16px">Write Roles</p>
      <v-select
        v-if="editable"
        label="Add Role"
        item-value="roleCode"
        item-text="roleDescription"
        :items="remainingWriteRoles"
        @input="addWriteRole"
      >
      </v-select>
      <v-chip
        class="chip"
        v-for="role in articleRoles.write"
        :close="editable"
        :key="role"
        @click:close="removeWriteRole(role)"
      >{{role}}
      </v-chip>
      <v-chip v-if="articleRoles.write.length === 0">MCITY</v-chip>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations('article', [
      'addReadRole',
      'addWriteRole',
      'removeReadRole',
      'removeWriteRole'
    ]),
    diffSet (original, subtract) {
      const differenceSet = new Set()
      for (const elem of original) {
        if (!subtract.has(elem)) {
          differenceSet.add(elem)
        }
      }
      return differenceSet
    }
  },
  computed: {
    ...mapState({
      articleRoles (state) {
        return this.editable ? state.article.articleEdits.roles : state.article.currentArticle.roles
      },
      roleList: state => state.roleList
    }),
    roleListNames () {
      return this.roleList.map(role => role.roleCode)
    },
    remainingReadRoles () {
      const readRoles = new Set([...this.articleRoles.read])
      const allRoles = new Set([...this.roleListNames])
      return [...this.diffSet(allRoles, readRoles)]
    },
    remainingWriteRoles () {
      const writeRoles = new Set([...this.articleRoles.write])
      const allRoles = new Set([...this.roleListNames])
      return [...this.diffSet(allRoles, writeRoles)]
    }
  },
  created () {
    this.$store.dispatch('fetchRoleListAction')
  }
}
</script>

<style>
.selector {
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}
.chip {
  margin: 2px 2px 2px 2px;
}
</style>
